import { render, staticRenderFns } from "./IntegracoesV2.vue?vue&type=template&id=37b060a0"
import script from "./IntegracoesV2.vue?vue&type=script&lang=ts"
export * from "./IntegracoesV2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports